import rootReducer from "./reducers";
import {createStore} from "redux";
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

//la création du store, auquel on passe le reducer (rootReducer), l'état initial (initialState), et, si besoin, des middleware.
// les middlewares, ici on utilise thunk, permettent d'appeler une fonction entre le dispatch d'une action et le reducer,
// c'est ça qui nous permet d'appeler addFilmAction par exemple.
const store = createStore(persistedReducer)
const persistor = persistStore(store)
export default { store, persistor }
